import moment from "moment"
import pdfMake from "pdfmake"
import {Footer, Header, Paragraph, TextRun, PageNumber, TabStopType, TabStopPosition} from "docx"

/**
 * Helper methods for exporting .docx files with docx.js, and .pdf files with pdfmake
 */
export default {
    methods: {

        // ----------- .docx methods ---------------

        // NB: docx.js API for fonts, margins, etc. is either borked or very badly documented -
        // so we keep things simple and use line breaks for spacing! (???)

        getDocxBaseSection() {
            return {
                headers: {
                    default: new Header({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun(this.exportHeader.left),
                                    new TextRun('\t' + this.exportHeader.right)
                                ],
                                tabStops: [
                                    {type: TabStopType.RIGHT, position: TabStopPosition.MAX}
                                ]
                            }),
                        ],
                    }),
                },
                footers: {
                    default: new Footer({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun(this.exportFooter.left),
                                    new TextRun({
                                        children: ['\tPage ', PageNumber.CURRENT]
                                    })
                                ],
                                tabStops: [
                                    {type: TabStopType.RIGHT, position: TabStopPosition.MAX}
                                ]
                            }),
                        ],
                    }),
                },
                children: [],
            }
        },

        createDocxTitle(text) {
            return new Paragraph({
                children: [
                    new TextRun({
                        text: text,
                        font: {name: this.getDocxFontName()},
                        size: this.docData.fontSize == 'large' ? 72 : 48,
                    })
                ]
            })
        },

        createDocxHeader(text) {
            return new Paragraph({
                children: [
                    new TextRun({
                        text: text,
                        font: {name: this.getDocxFontName()},
                        size: this.docData.fontSize == 'large' ? 54 : 36,
                    })
                ]
            })
        },

        createDocxParagraph(text, options) {
            return new Paragraph({
                spacing: {
                    before: 0,
                    after: 50,
                },
                children: [
                    new TextRun({
                        text: text,
                        font: {name: this.getDocxFontName()},
                        size: this.docData.fontSize == 'large' ? 36 : 24,
                        bold: options ? options.bold : false,
                        italics: options ? options.italics : false
                    }).break()
                ]
            })
        },

        getDocxFontName() {
            if (this.docData.fontFace == 'serif') {
                return 'Times'
            } else if (this.docData.fontFace == 'mono') {
                return 'Courier'
            } else {
                return 'Arial'
            }
        },

        // ----------- .pdf methods ---------------

        initPdfMakeFonts() {
            pdfMake.fonts = {
                mono: {
                    normal: window.location.origin + '/fonts/CutiveMono-Regular.ttf',
                    bold: window.location.origin + '/fonts/CutiveMono-Regular.ttf',
                    italics: window.location.origin + '/fonts/CutiveMono-Regular.ttf',
                    bolditalics: window.location.origin + '/fonts/CutiveMono-Regular.ttf',
                },
                sans: {
                    // normal: 'Helvetica',
                    normal: window.location.origin + '/fonts/OpenSans-VariableFont_wdth,wght.ttf',
                    bold: window.location.origin + '/fonts/OpenSans-VariableFont_wdth,wght.ttf',
                    italics: window.location.origin + '/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf',
                    bolditalics: window.location.origin + '/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf'
                },
                serif: {
                    normal: window.location.origin + '/fonts/PTSerif-Regular.ttf',
                    bold: window.location.origin + '/fonts/PTSerif-Bold.ttf',
                    italics: window.location.origin + '/fonts/PTSerif-Italic.ttf',
                    bolditalics: window.location.origin + '/fonts/PTSerif-BoldItalic.ttf',
                },
            }
        },

        getPdfBaseDocDefinition() {
            return {
                pageSize: 'LETTER',
                pageMargins: 60,

                header: {
                    columns: [
                        {
                            width: '60%',
                            text: this.exportHeader.left,
                            margin: [60, 20, 0, 20] // left, top, right, bottom (mm?)
                        },
                        {
                            text: this.exportHeader.right,
                            margin: [0, 20, 60, 20],
                            alignment: 'right'
                        }
                    ]
                },
                footer: (currentPage, pageCount, pageSize) => {
                    return {
                        columns: [
                            {
                                width: '75%',
                                text: this.exportFooter.left,
                                margin: [60, 20, 0, 20]
                            },
                            {
                                text: `Page ${currentPage}`, // of ${pageCount}`,
                                alignment: 'right',
                                margin: [0, 20, 60, 20]
                            }
                        ]
                    }
                },

                content: [],
                styles: {
                    title: {
                        fontSize: this.docData.fontSize == 'large' ? 24 : 18,
                        bold: true,
                        margin: [0, 10, 0, 10]
                    },
                    header: {
                        fontSize: this.docData.fontSize == 'large' ? 18 : 14,
                        bold: true,
                        margin: [0, 10, 0, 10]
                    },
                    paragraph: {
                        fontSize: this.docData.fontSize == 'large' ? 15 : 12,
                        margin: [0, 10, 0, 10]
                    },
                    paragraphBold: {
                        fontSize: this.docData.fontSize == 'large' ? 15 : 12,
                        bold: true,
                        margin: [0, 10, 0, 10]
                    },
                    paragraphItalic: {
                        fontSize: this.docData.fontSize == 'large' ? 15 : 12,
                        italics: true,
                        margin: [0, 10, 0, 10]
                    },
                },
                defaultStyle: {
                    font: (this.docData.fontFace ? this.docData.fontFace : 'sans')
                }
            }
        }
    }

}